import React from 'react';
import { SnackbarElaboration } from '@/contexts/elaboracao_planos/sknackbar';

export const useSnackbarElaboration = () => React.useContext(SnackbarElaboration);
